import { toArray } from "react-emoji-render";

const parseEmoji = text =>
  toArray(text).reduce(
    (previous, current) =>
      typeof current === "string"
        ? previous + current
        : previous + current.props.children,
    ""
  );

export default parseEmoji;
